export default "__VITE_ASSET__bfb01649__"